import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>
          Jenish Shrestha
        </h1>
        <p>Software Engineer</p>
        <div>
          <a href="https://github.com/jenish1231" target="_blank" style={{ color: "white" }}><i class="fa fa-github" aria-hidden="true"></i></a>
          &nbsp;
          <a href="https://www.linkedin.com/in/jenish-shrestha-365061143/" target="_blank" style={{ color: "white" }}>
            <i class="fa fa-linkedin-square" aria-hidden="true"></i>
          </a>
        </div>
      </header>
    </div>
  );
}

export default App;
